module.exports = __webpack_public_path__ + "static/media/Sahara_forest_crop_mobile.6de05496.jpg";